const contact = [
    {
        sectionId: "contact",
        language: "en",
        title: "Contact Me",
        content: {
            intro: {
                text: "If you want to hire me, you can reach me through my personal email, [email], or my phone, [phone], or through any of the links below.",
                email: "mdaffonso@gmail.com",
                phone: "+55 (51) 993 868 729",
            },
            links: [
                { 
                    name: "facebook",
                    icon: "fb",
                    href: "https://www.facebook.com/mdaffonso",
                },
                { 
                    name: "instagram",
                    icon: "insta",
                    href: "https://www.instagram.com/mdaffonso/",
                },
                { 
                    name: "whatsapp",
                    icon: "wapp",
                    href: "https://wa.me/5551993868729?text=Hi! I would like to hire you!",
                },
                { 
                    name: "github",
                    icon: "ghub",
                    href: "https://github.com/mdaffonso",
                },
            ]
        },
    },
    {
        sectionId: "contact",
        language: "pt",
        title: "Entre em Contato Comigo",
        content: {
            intro: {
                text: "Se você quiser contratar os meus serviços, você pode enviar um email para [email], ou pode me contatar pelo telefone [phone], ou por qualquer dos links abaixo.",
                email: "mdaffonso@gmail.com",
                phone: "+55 (51) 993 868 729",
            },
            links: [
                { 
                    name: "facebook",
                    icon: "fb",
                    href: "https://www.facebook.com/mdaffonso",
                },
                { 
                    name: "instagram",
                    icon: "insta",
                    href: "https://www.instagram.com/mdaffonso/",
                },
                { 
                    name: "whatsapp",
                    icon: "wapp",
                    href: "https://wa.me/5551993868729?text=Oi! Eu quero te contratar!",
                },
                { 
                    name: "github",
                    icon: "ghub",
                    href: "https://github.com/mdaffonso",
                },
            ]
        },
    }
]

export default contact